/* eslint-disable max-len */
/* eslint-disable react/no-danger */
/* eslint-disable array-callback-return */
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import bindAll from 'lodash.bindall';
import virtualBlockInfo, {categoryObj} from './virtual-block-info';
import {closeWhiteList} from '../../reducers/modals';
import Box from '../box/box.jsx';
import styles from './white-list.css';

const objTitle = categoryObj;

const changStatus = target => {
    if (typeof target === 'string') {
        if (document.getElementById(target).previousElementSibling.checked) {
            document.getElementById(target).style.opacity = '1';
        } else {
            document.getElementById(target).style.opacity = '.4';
        }
        return false;
    }
    if (target.checked) {
        target.dataset.k && (document.getElementById(target.dataset.k).style.opacity = '1');
    } else {
        target.dataset.k && (document.getElementById(target.dataset.k).style.opacity = '.4');
    }
};

class WhiteList extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'setRef',
            'handleData',
            'handleSave',
            'handleSubmit'
        ]);
    }
    componentDidMount () {
        const toolboxXml = this.props.vm.toolboxXML;
        const toolbox = this.getItem(toolboxXml);
        Object.values(virtualBlockInfo).map(categoryItem => {
            categoryItem.forEach(item => {
                const value = item.value;
                const id = item.id;
                const block = this.getItem(value);
                if (toolboxXml && !toolbox.includes(block.join())) {
                    document.getElementById(id).previousElementSibling.checked = false;
                    changStatus(id);
                }
            });
        });
        this.ref.onclick = this.handleClick;
    }
    getItem (toolboxXml) {
        const re = /<block[^>]*type=\\?"(.[^\\"]*)/g;
        let result = [];
        let crt;
        while ((crt = re.exec(toolboxXml)) !== null){
            result = result.concat(crt[1]);
        }
        return result;
    }
    handleClick (e) {
        const target = e.target;
        changStatus(target);
        if (target.nodeName !== 'SPAN') {
            return;
        }
        const category = target.dataset.category;
        const inputArr = document.getElementsByName(category);
        if (target.dataset.st === 'true'){
            for (let i = 0; i < inputArr.length; i++){
                inputArr[i].checked = true;
                changStatus(inputArr[i]);
            }
            target.dataset.st = 'false';
            target.innerHTML = '全不选';
        } else if (target.dataset.st === 'false'){
            for (let i = 0; i < inputArr.length; i++){
                inputArr[i].checked = false;
                changStatus(inputArr[i]);
            }
            target.dataset.st = 'true';
            target.innerHTML = '全选';
        }
    }

    handleData (form) {
        const blocksObj = {};
        for (let i = 0; i < form.elements.length; i++) {
            const field = form.elements[i];
            if (!field.name || field.type === 'submit' || field.type === 'button') continue;
            if (field.checked) {
                if (blocksObj[field.name] === undefined) {
                    blocksObj[field.name] = [`${objTitle[field.name].xml}`, `${objTitle[field.name].xmlclose}`];
                }
                blocksObj[field.name].splice(blocksObj[field.name].length - 1, 0, field.value);
            }
        }
        for (const item in blocksObj) {
            blocksObj[item] = blocksObj[item].join('');
        }
        return blocksObj;
    }

    handleSave (e) {
        e.stopPropagation();
        e.preventDefault();
        const xml = this.handleData(e.target);
        this.props.vm.setToolbox(JSON.stringify(xml));
        this.props.setEditState();
        this.props.onRequestClose();
        return false;
    }

    handleSubmit (e) {
        return this.handleSave(e);
    }
    setRef (ref) {
        this.ref = ref;
    }
    render () {
        let categoryHtml = '';
        const dom = Object.values(virtualBlockInfo).map((categoryItem, index) => {
            categoryHtml = `<div class="category"><div class="category-top"><h5>${Object.values(objTitle)[index].name}</h5><span class="op" data-category='${Object.keys(virtualBlockInfo)[index]}' data-st='false'>全不选</span></div><div class="blocklist">`;
            categoryItem.forEach(item => {
                const name = item.category;
                const id = item.id;
                const imgUrl = item.img;
                const value = item.value;
                categoryHtml += `<label class='radio-box'>
                    <input type='checkbox' class='radio-radio' name='${name}' value='${value}' data-k='${id}' checked />
                    <img src='${imgUrl}' alt='pic' id='${id}' />
                </label>`;
            });
            categoryHtml += '</div></div>';
            return categoryHtml;
        });
        return (
            <Box className={styles.wrapper}>
                <form
                    className={styles.form}
                    id="form"
                    ref={this.setRef}
                    onSubmit={this.handleSubmit}
                >
                    <div className={styles.top}>
                        <h3>{'白名单编辑'}</h3>
                        <span><button>{'保存'}</button><i onClick={this.props.onRequestClose}>{'取消'}</i></span>
                    </div>
                    <div
                        className={styles.categoryBox}
                        dangerouslySetInnerHTML={{__html: dom.join('')}}
                        id="myCBox"
                    />
                </form>
            </Box>
        );
    }
}

WhiteList.propTypes = {
    onRequestClose: PropTypes.func.isRequired,
    setEditState: PropTypes.func,
    vm: PropTypes.shape({
        setToolbox: PropTypes.func,
        toolboxXML: PropTypes.string
    })
};

const mapStateToProps = state => ({
    vm: state.scratchGui.vm
});

const mapDispatchToProps = dispatch => ({
    onRequestClose: () => dispatch(closeWhiteList())
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WhiteList);

export const intrinsicBlocksMap = virtualBlockInfo;
